import React from 'react';
import EricaHero from '../components/erica/EricaHero';
import EricaHowItWorks from '../components/erica/EricaHowItWorks';
import EricaConnectors from '../components/erica/EricaConnectors';
import EricaAskAnywhere from '../components/erica/EricaAskAnywhere';
import EricaModules from '../components/erica/EricaModules';
import EricaUseCases from '../components/erica/EricaUseCases';
import EricaDemoStory from '../components/erica/EricaDemoStory';
import EricaSecurity from '../components/erica/EricaSecurity';
import EricaLogos from '../components/erica/EricaLogos';
import EricaFAQ from '../components/erica/EricaFAQ';
import DemoRequestSection from '../components/erica/DemoRequestSection';
import SEO from '../components/shared/SEO';
import { COPY } from '../i18n/copy';
import { useI18n } from '../i18n/useI18n';

const EricaLandingPage: React.FC = () => {
  const { lang } = useI18n();
  const c = COPY[lang];

  React.useEffect(() => {
    const id = window.location.hash.replace('#', '').trim();
    if (!id) return;
    const el = document.getElementById(id);
    el?.scrollIntoView({ behavior: 'auto', block: 'start' });
  }, []);

  return (
    <>
      <SEO title={c.seo.title} description={c.seo.description} lang={lang} />
      <EricaHero />
      <EricaHowItWorks />
      <EricaConnectors />
      <EricaAskAnywhere />
      <EricaModules />
      <EricaUseCases />
      <EricaDemoStory />
      <EricaSecurity />
      <EricaLogos />
      <EricaFAQ />
      <DemoRequestSection />
    </>
  );
};

export default EricaLandingPage;
